import React from 'react';
import * as Fa6Icons from 'react-icons/fa6';
import SafeIcon from '../common/SafeIcon';

const { FaThreads, FaInstagram, FaFacebookF } = Fa6Icons;

const socials = [
  {
    name: 'Threads',
    url: 'https://www.threads.com/@homy.hk',
    icon: FaThreads,
    color: 'hover:text-white'
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com/homy.hk',
    icon: FaInstagram,
    color: 'hover:text-pink-500'
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/profile.php?id=61578745554661',
    icon: FaFacebookF,
    color: 'hover:text-blue-500'
  }
];

const SocialLinks = () => {
  return (
    <nav className="flex items-center gap-6 mt-4" aria-label="Homy Tech 社交媒體">
      {socials.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          className={`text-slate-500 text-xl transition-all duration-300 hover:scale-125 ${social.color}`}
          aria-label={`在 ${social.name} 關注 Homy Tech`}
          title={`${social.name} — Homy Tech`}
        >
          <SafeIcon icon={social.icon} aria-hidden="true" />
        </a>
      ))}
    </nav>
  );
};

export default SocialLinks;